import React from 'react';
import { Paper, Typography } from '@mui/material';

/**
 * StatTile — compact KPI tile for the Report tab (mockup screen 9): label, big
 * value, and an optional hint/delta line.
 */
const StatTile = function StatTile({
  label,
  value,
  valueColor = 'text.primary',
  hint = null,
}) {
  return (
    <Paper sx={{ flex: 1, minWidth: 0, p: 1.75, borderRadius: '16px' }}>
      <Typography sx={{ fontSize: 12, color: '#94a3b8' }} noWrap>
        {label}
      </Typography>
      <Typography
        sx={{ fontSize: 26, fontWeight: 700, color: valueColor, mt: 0.5 }}
        noWrap
      >
        {value}
      </Typography>
      {hint ? (
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 600,
            color: 'greys.secondary',
            mt: 0.25,
          }}
        >
          {hint}
        </Typography>
      ) : null}
    </Paper>
  );
};

export default StatTile;
